var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3799_51853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3799_51853)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    r: 18,
    fill: "url(#paint0_linear_3799_51853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3582 30.0682V26.7273H38.6323V30.0682H34.0386V42H29.9519V30.0682H25.3582Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.45,
    y: 16.45,
    width: 35.1,
    height: 35.1,
    rx: 17.55,
    stroke: "white",
    strokeWidth: 0.9,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3799_51853",
    x: 0.499999,
    y: 0.699999,
    width: 66.6,
    height: 66.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3799_51853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3799_51853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3799_51853",
    x1: 23.45,
    y1: 17.8,
    x2: 40.1,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#794BDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938482,
    stopColor: "#812A8E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3799_51853"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownToken);
export default __webpack_public_path__ + "static/media/unknown_token.a5662846cd9bb9e0b66937384c7ef10f.svg";
export { ForwardRef as ReactComponent };